import { ChevronRightIcon} from '@heroicons/react/24/solid';
import { deeplinkMobile } from '../../utils/constants';

const Restaurant = () => {
	const ua = navigator.userAgent;

	const isAndroid = /Android/i.test(ua);
	const isIOS = /iPhone|iPad|iPod/i.test(ua);

	const openApp = (app) => {
		if (isAndroid) {
			window.location.href = app.androidScheme;
			return;
		}

		if (isIOS) {
      window.location.href = app.iosScheme;
      return;
		}
	};

	return (
		<div className={`min-h-screen bg-slate-50`}>
			<div className='max-w-md mx-auto px-5 py-6'>
				<div className='flex items-center justify-between mb-6'>
					<div>
						<h1 className='text-2xl font-black text-[var(--rose-violet)]'>UFOOD</h1>
						<p className='text-xs text-gray-500'>QR Redirector</p>
					</div>
				</div>
				<div className='mb-4'>
					<h3 className={`font-bold text-md text-slate-800`}>Pilih Aplikasi</h3>
					<p className='text-xxs text-slate-500'>Buka pemesanan melalui aplikasi partner.</p>
				</div>
				<div className='space-y-3'>
					{deeplinkMobile.map((app) => (
						<button key={app.name} onClick={() => openApp(app)} className={`w-full bg-white border-slate-100 border rounded-2xl p-4 flex items-center justify-between transition shadow-sm`}>
							<div className='flex items-center'>
								<div className={`w-12 h-12 rounded-2xl flex items-center justify-center font-bold ${app?.bgColor} ${app?.textColor} tracking-wide border border-blue-100/30`}>{app.short}</div>

								<div className='text-left ml-4'>
									<h4 className={`font-semibold bg-white text-slate-800`}>{app.name}</h4>

									<p className={`text-xxs bg-white text-slate-400`}>{app.desc}</p>
								</div>
							</div>

							<ChevronRightIcon className='w-4 h-4 text-slate-400' />
						</button>
					))}
				</div>
			</div>
		</div>
	);
};

export default Restaurant;
